export const keys = {
  login: 'personefy_login',
  logout: 'personefy_logout',
  refresh: 'jwt_refresh_token',
  pwdResetInit: 'initiate_password_reset',
  pwdResetConfirm: 'confirm_password_reset',
  acceptTerms: 'user_accept_terms',
  lastUsedClientUpdate: 'set_user_last_used_business_unit',
};
